import { PlaceholderPage } from "@/components/common/PlaceholderPage";

export function CareersPage() {
  return (
    <PlaceholderPage
      badge="Careers"
      title="Careers at COSX"
      description="We're building the future of AI for regulated industries. Open roles coming soon."
      path="/careers"
      metaTitle="COSX — Careers"
    />
  );
}
